import React, { useEffect, useState } from 'react';

export default function ResearchCard({ title, description, delay = 0 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(t);
  }, [delay]);

  return (
    <div
      className={`group border border-gray-200 p-6 transition-all duration-700 hover:border-gray-400 hover:shadow-lg ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
      style={{ backgroundColor: '#fbfcf3' }}
    >
      <div className="w-12 h-1 bg-gray-900 mb-4 transition-all duration-300 group-hover:w-20" />
      <h3 className="text-xl font-medium mb-3 transition-colors duration-300 group-hover:text-gray-600">
        {title}
      </h3>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
  );
}
